/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type _OutcomeRequestLabel = typeof _OutcomeRequestLabel[keyof typeof _OutcomeRequestLabel] | null;


export const _OutcomeRequestLabel = {
  interested: 'interested',
  not_interested: 'not_interested',
} as const;
